import { render, staticRenderFns } from "./SummaryReportOfStudentsProgressTable.vue?vue&type=template&id=27857755&"
import script from "./SummaryReportOfStudentsProgressTable.vue?vue&type=script&lang=js&"
export * from "./SummaryReportOfStudentsProgressTable.vue?vue&type=script&lang=js&"
import style0 from "./SummaryReportOfStudentsProgressTable.vue?vue&type=style&index=0&id=27857755&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports